// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o_uN","name":"styles_name__aJWDo","phone":"styles_phone__1yfIK"};